const tasks = `
    assignedId
    assignedUser {
        created
        email
        phone_number
        sub
        username
    }
    publicCaseId
    profileId
    profile {
        firstName
        lastName
    }
    caseReference {
        type
        caseId
        caseObject {
            path
            profile {
                firstName
                lastName
            }
        }
    }
    created
    creatorId
    creatorUser {
        created
        email
        phone_number
        sub
        username
    }
    dueDate
    getTask
    id
    note
    taskId
    taskStatus
`;

export default tasks;
